var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDroneVideoIcon = function SvgDroneVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 512 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 252,
    fill: "#2D4A58"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 237,
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M259.911 137.356 369.12 340.173c4.104 7.621-3.864 16.075-11.714 12.43l-99.562-46.225a4.5 4.5 0 0 0-3.79 0l-99.562 46.225c-7.85 3.645-15.817-4.809-11.714-12.43l109.209-202.817c1.699-3.155 6.225-3.155 7.924 0"
  })));
};
export default SvgDroneVideoIcon;